import type { Category } from '@twisto/api-cms'
import { Typography } from '@twisto/components/atoms/typography'

import * as styles from '../articles-search-input.styles'

type Props = {
  category: Category | null
}

export const ArticleSearchBreadcrumb = ({ category }: Props) => {
  const breadcrumbs = []
  let currentCategory = category
  while (currentCategory !== null) {
    breadcrumbs.push(currentCategory.name)
    currentCategory = currentCategory.parent as Category | null
  }

  return (
    <Typography color="textTertiary" css={styles.breadcrumb} variant="b3">
      {breadcrumbs.reverse().map((breadcrumb) => (
        <span key={breadcrumb} css={styles.breadcrumbItem}>
          {breadcrumb}
        </span>
      ))}
    </Typography>
  )
}
